<!-- 自定义circle -->
<style lang="stylus" scoped>
.circle
  height 174px
  padding 10px
  color #fff
  text-align center
  .main
    position relative
    width 100%
    height 100%
    .item
      position absolute
      width:87px;
      height:86px;
      border-radius:50%;
      display: flex
      align-items center
      justify-content center
      font-size: 11px;
      &:nth-child(odd)
        border:2px solid rgba(13, 197, 246, 1);
      &:nth-child(even)
        border:2px solid rgba(255, 176, 86, 1);
      &:nth-child(2)
        bottom: 10px
        left: 80px
      &:nth-child(3)
        left: 160px
      &:nth-child(4)
        bottom: 10px
        left: 250px
      &:nth-child(5)
        right: 10px
</style>

<template>
  <boxWrap :name="name">
    <div class="circle">
      <div class="main">
        <div class="item" v-for="(item, index) in circleData" :key="index">
          <div>
            <div style="margin-bottom: 7px">{{item.name}}</div>
            <div>{{item.value}}</div>
          </div>
        </div>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import boxWrap from 'components/dashboard/common/boxWrap';
export default {
  data() {
    return {
      name: '扶贫情况',
      circleData: [
        {name: '贫困户总数', value: '20012'},
        {name: '产业扶贫金额', value: '1028472'},
        {name: '未脱贫户数', value: '16002'},
        {name: '电商扶贫金额', value: '2013210'},
        {name: '已脱贫户数', value: '4010'}
      ]
    }
  },
  components: {
    boxWrap
  },
  mounted() {

  }
}

</script>



// WEBPACK FOOTER //
// index.vue?28e5ca28